import Plot from "react-plotly.js";


export default function PlotlyPlot({data}) {
   
   return <Plot
      data={data}
      layout={{
         dragmode: "zoom",
         showlegend: true,
         xaxis: {showgrid: false, showspikes: true, spikemode: "across"},
         yaxis: {showgrid: false, },
         hovermode: 'x unified',
         hoverlabel: {namelength: 0}
      }}
      style={{ width: "100%", height: "400px" }}
   />
}